import React from 'react';
import { PrivacyPolicyContainer } from './PrivacyStyles.styles';
// This is done
const PrivacyPolicySummary = () => {
  return (
    <>
      <PrivacyPolicyContainer>
        <h3>Changes to This Privacy Policy</h3>

        <p>
          We may update this Privacy Policy from time to time to reflect changes
          to our practices, services, platform features, technology providers,
          or applicable legal requirements. When we update this Privacy Policy,
          we will post the revised version on this page and update the
          &apos;Last Updated&apos; date.
        </p>

        <p>
          Where appropriate or required by law, we may provide additional notice
          of material changes, such as through the platform, by email, or
          through another appropriate method. We encourage you to review this
          Privacy Policy periodically to remain informed about how we collect,
          use, disclose, store, and protect personal information.
        </p>
      </PrivacyPolicyContainer>

      <PrivacyPolicyContainer>
        <h3>Contact Us</h3>

        <p>
          If you have questions, concerns, or complaints about this Privacy
          Policy, our privacy practices, or how your personal information is
          handled, or if you would like to make a request regarding your
          personal information, please contact Yoda Safety Services at:
        </p>

        <ul>
          <li>
            Email:{' '}
            <a href="mailto:yodasafetyservices1@outlook.com">
              yodasafetyservices1@outlook.com
            </a>
          </li>
        </ul>

        <p>
          We will review and respond to privacy-related inquiries and requests
          within a reasonable period and in accordance with applicable legal
          requirements.
        </p>
      </PrivacyPolicyContainer>
      <PrivacyPolicyContainer>
        <h3>Minors</h3>

        <p>
          Yoda Safety Services provides workplace safety training and related
          services that may, in some circumstances, be used by individuals under
          the age of 18, including where training is assigned through an
          employer or other organization.
        </p>

        <p>
          We do not knowingly collect personal information from minors beyond
          what is reasonably necessary to provide training, maintain training
          records, provide our services, or as otherwise permitted by applicable
          law. Where consent from a parent, guardian, or other authorized person
          is required by applicable law, we will take reasonable steps to obtain
          the required consent.
        </p>

        <p>
          If you believe that personal information relating to a minor has been
          collected or handled inappropriately, please contact us using the
          information provided in this Privacy Policy.
        </p>
      </PrivacyPolicyContainer>
    </>
  );
};

export default PrivacyPolicySummary;
